let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("979lp")).then(() => parcelRequire('7yOXm'));